
<swiper-container [pagination]="{ clickable: true }" [spaceBetween]="50" [navigation]="navigation" [slidesPerView]="1" [ngClass]="{'card-carousel': ((unitBusinessVirtualDebitCards$ | async)?.length > 1 || false)}" (swiperslidechange)="activeindexchange($event)" #swiper>
  @for (businessVirtualDebitCard of (unitBusinessVirtualDebitCards$ | async); track businessVirtualDebitCard){
    <swiper-slide>
      <terra-unit-card 
        [cardStatus]="businessVirtualDebitCard.cardStatus"
        [cardId]="businessVirtualDebitCard.id"
        [holderFullName]="businessVirtualDebitCard.fullName"
        [cardNumber]="businessVirtualDebitCard.last4Digits"
        [exp]="businessVirtualDebitCard.expirationDate"
        [viewSensitive]="viewSensitiveData$ | async" 
        [loadingSensitiveData]="loadingSensitiveData$ | async" />
    </swiper-slide>
  }
</swiper-container>